module.exports = __webpack_public_path__ + "img/freespin3.8df9ea67.png";